'use strict';

/* Directives */

angular.module('substoreApp.directives')

/**
 * Directive to show action button on MyProducts
 */
    .directive('capMyproductsAction', function () {
        return {
            restrict: 'A',
            scope: {
                product: "=",
                productOption: "=",
                action: "=",
                actions: "="
            },
            link: function (scope, element, attrs) {
                scope.style = (attrs.spaceAbove ? { 'margin-top' : '10px' } : { });

                scope.$watch("actions.isInProgress(action, productOption.uniqueSubscriptionId)", function(inProgress) {
                    if (inProgress)
                        scope.productOption.isDetailsCollapsed = true;
                });
            },
            templateUrl: "templates/myproductsaction.html"
        }
    });